import { render, staticRenderFns } from "./CourseMarkupInput.vue?vue&type=template&id=f01f2906"
import script from "./CourseMarkupInput.vue?vue&type=script&lang=js"
export * from "./CourseMarkupInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports